import axios from 'axios';
import store, { history } from '../store';

export const TEAM_JOINED = 'TEAM_JOINED';

const joinTeams = teamIds => (
  (dispatch) => {
    return axios.post(`/api/teams`, {
      team_ids: teamIds,
    })
      .then(() => {
        teamIds.forEach(teamId => {
          dispatch({
            type: TEAM_JOINED,
            teamId,
          });
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      });
  }
);

export default joinTeams;
